import measurementService from '../service/measurement'

let d = new Date();
const end = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);
const start = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 * 52);

const state = {
    query: {
        minValueActive: false,
        maxValueActive: false,
        telemetry: "",
        minValue: null,
        maxValue: null,
        dateRange: [start, end],
        tags: [],
        macAddress: "",
        measurementType: undefined,
        partial: undefined,
        error: undefined,
        upload: undefined,
        onlyMine: false,
        page: 1,
        pageSize: 10,
        paths: [],
        favorite: false
    },
    tags: [],
    trend: [],
    searchResult: {
        total: 0,
        measurements: []
    },
    loading: false,
}

const actions = {
    updateQuery({ commit }, query) {
        commit('setQuery', query)
    },

    getTags({ commit }) {
        measurementService.getTags().then(tags => {
            commit('setTags', tags)
        })
    },
    deleteMeasurements({ commit }, { query }) {
        commit('setLoading', true)
        measurementService.deleteMeasurements(query).then(() => {
            commit('setLoading', false)
        })
    },
    getMeasurements({ commit }, query) {
        commit('setQuery', query)
        commit('setLoading', true)

        measurementService.searchMeasurements(query).then(result => {
            commit('setSearchResult', result)
        }).finally(() => {
            commit('setLoading', false)
        })
    }
}
const mutations = {
    setTrend(state, trend) {
        state.trend = trend
    },
    setTags(state, tags) {
        state.tags = tags
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setSearchResult(state, result) {
        state.searchResult = result
        state.loading = false
    },
    setQuery(state, query) {
        state.query = query
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



